/**
 * 权限参数
 * 组中其中一个权限开通 模块就会展示
 */
export const parentName = "企业管理";
export interface PowerConfig {
  [key: string]: string[];
}

/** 审批 */
export const POWER_APPROVE: PowerConfig = {
  APPROVE: ["审批报销", "工作台"], // 审批
};
/** 预算 */
export const POWER_BUDGET: PowerConfig = {
  BUDGET: [parentName, "进入预算"], // 预算
};

/** 进销存 */
export const POWER_PURCHASE_ID = [parentName, "进入进销存"];

export const POWER_PURCHASE: PowerConfig = {
  // PURCHASE: [parentName, "进入进销存"], // 进销存
  PURCHASE_PURCHASE: [parentName, "进入进销存", "入库管理", "采购入库单"], // 进销存 - 采购入库单
  PURCHASE_SALES: [parentName, "进入进销存", "出库管理", "销售出库单"], // 进销存 - 销售入库单
  PURCHASE_RECEIPT: [parentName, "进入进销存", "财务单据", "收款单"], // 进销存 - 收款单
  PURCHASE_PAYMENT: [parentName, "进入进销存", "财务单据", "付款单"], // 进销存 - 付款单
  PURCHASE_PURCHASE_LIST: [parentName, "进入进销存", "入库管理", "入库单据表"], // 进销存 - 入库单据表
  PURCHASE_SALES_LIST: [parentName, "进入进销存", "出库管理", "出库单据表"], // 进销存 - 出库单据表
  PURCHASE_EARLY_WARNING: [parentName, "进入进销存", "报表分析", "保质期预警查询表"],
  PURCHASE_COMMODIFY_WARNING: [parentName, "进入进销存", "报表分析", "存货库存预警表"],
};

export const POWER_FINANCIAL_ID = [parentName, "进入财务"];

/** 财务云 */
export const POWER_FINANCIAL: PowerConfig = {
  // FINANCIAL: [parentName, "进入财务"],
  FINANCIAL_RECORD: [parentName, "进入财务", "录凭证"],
  FINANCIAL_CHECK: [parentName, "进入财务", "查凭证"],
  FINANCIAL_ACCOUNT_SHEET: [parentName, "进入财务", "账簿", "科目余额表"],
  FINANCIAL_JOURNAL: [parentName, "进入财务", "出纳", "日记账"],

  FINANCIAL_INPUT_INVOICE_LIST: [parentName, "进入财务", "智能凭证中间件", "进项发票列表"],
  FINANCIAL_OUTPUT_INVOICE_LIST: [parentName, "进入财务", "智能凭证中间件", "销项发票列表"],
  FINANCIAL_PURCHASE_LIST: [parentName, "进入财务", "智能凭证中间件", "进销存单据列表"],
  FINANCIAL_APPROVE_LIST: [parentName, "进入财务", "智能凭证中间件", "审批单据列表"],
};

/** 财务报表 */
export const POWER_FINANCIAL_LIST: PowerConfig = {
  // FINANCIAL_LIST: [parentName, "进入财务"],
  FINANCIAL_LIST_BALANCE_SHEET: [parentName, "进入财务", "报表", "资产负债表"],
  FINANCIAL_LIST_PROFIT_SHEET: [parentName, "进入财务", "报表", "利润表"],
  FINANCIAL_LIST_FLOWS_SHEET: [parentName, "进入财务", "报表", "现金流量表"],
  FINANCIAL_LIST_OLD_VERSION_SHEET: [parentName, "进入财务", "报表", "老板报表"],
  FINANCIAL_LIST_PROPROFIT_SHEET: [parentName, "进入财务", "报表", "项目利润表"],
};

/** 财税分析 */
export const POWER_FISCAL_ANALYSIS: PowerConfig = {
  // FISCAL_ANALYSIS: [parentName, "进入财务"],
  FISCAL_ANALYSIS_DETECTION: [parentName, "进入财务", "财税分析", "财税检测"],
};

/** 企业信息 */
export const POWER_COMPANY: PowerConfig = {
  COMPANY: ["系统管理", "企业信息管理"],
};
